export default {
  wallet: {
    title: 'กระเป๋าเงิน',
    balance: 'ยอดเงิน',
    deposit: 'ฝากเงิน',
    withdraw: 'ถอนเงิน',
    rollover: 'ยอดหมุนเวียน',
    transaction: 'รายการธุรกรรม',
    myBet: 'เดิมพันของฉัน',
    totalBalance: 'ยอดเงินรวม',
    withdrawableBalance: 'ยอดที่ถอนได้',
    bonus: 'โบนัส',
    bonusBalance: 'ยอดโบนัส',
    cashBalance: 'ยอดเงินสด',
    withdrawable: 'ถอนได้',
    depositNow: 'ฝากเงินตอนนี้',
    getBonus: 'รับโบนัส',
    bonusGames: 'เกมโบนัส',
    playNow: 'เล่นเลย',
    fiatAccount: 'บัญชีเงินสด',
    cash: 'เงินสด',
    rules: 'กติกา',
    ruleQ1: '1. โบนัสคืออะไร?',
    ruleA1: 'โบนัสคือรางวัลที่แพลตฟอร์มมอบให้หลังจากเข้าร่วมกิจกรรม และสามารถใช้วางเดิมพันในเกมโบนัสที่กำหนดได้',
    ruleQ2: '2. ฉันจะใช้โบนัสได้อย่างไร?',
    ruleA2: 'โบนัสจะใช้เดิมพันได้ก็ต่อเมื่อยอดเงินสดหมดแล้วเท่านั้น โบนัสต้องทำยอดเทิร์นโอเวอร์ให้ครบก่อนจึงจะแปลงเป็นเงินสดได้',
    ruleQ3: '3. เกมใดบ้างที่รองรับการเดิมพันด้วยโบนัส?',
    ruleA3: 'เกมสล็อตส่วนใหญ่รองรับการเดิมพันด้วยโบนัส ดูรายการเกมโดยละเอียดได้ที่หน้าเกมโบนัส',
    ruleQ4: '4. มีข้อจำกัดในการแปลงโบนัสเป็นเงินสดหรือไม่?',
    ruleA4: 'เมื่อทำยอดเทิร์นโอเวอร์ของโบนัสครบแล้ว คุณสามารถแปลงโบนัสเดิมเป็นเงินสดได้ที่ศูนย์รางวัล กำไรจากโบนัสที่เหลือจะถูกส่งกลับไปยังกระเป๋าโบนัส และจะคำนวณยอดเทิร์นโอเวอร์ใหม่',
    ruleQ5: '5. มีข้อจำกัดในการแปลงกำไรจากโบนัสเป็นเงินสดหรือไม่?',
    ruleA5: 'กำไรจากโบนัสต้องทำยอดเทิร์นโอเวอร์ 15 เท่า กำไรจากโบนัสสูงสุดที่แปลงเป็นเงินสดได้คือ USDT5,000.00 และเดิมพันสูงสุดต่อครั้งคือ USDT1,000.00',
    ruleQ6: '6. ยอดเทิร์นโอเวอร์คำนวณอย่างไร?',
    ruleA6: 'เกมสล็อต: ยอดเดิมพัน = ยอดเทิร์นโอเวอร์ เกมอื่น ๆ: ยอดเดิมพัน = ค่าสัมบูรณ์ของกำไร (สูงสุดไม่เกินยอดเดิมพัน)',
    select: 'เลือก',
    currency: 'สกุลเงิน',
    loading: 'กำลังโหลด...',
    noMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
    noData: 'ไม่มีข้อมูล',
    colType: 'ประเภท',
    colTime: 'เวลา',
    colStatus: 'สถานะ',
    colAmount: 'จำนวน',
    colBalance: 'ยอดคงเหลือ',
    allType: 'ทุกประเภท',
    allStats: 'ทุกสถานะ',
    colWallet: 'กระเป๋าเงิน',
    colCurrent: 'ปัจจุบัน',
    colRequired: 'ที่ต้องการ',
    colStats: 'สถานะ',
    totalVaultBalance: 'ยอดตู้เซฟรวม',
    amount: 'จำนวน',
    availableBalance: 'ยอดที่ใช้ได้:',
    max: 'สูงสุด',
    depositInVault: 'ฝากเข้าตู้เซฟ',
    depositCurrency: 'สกุลเงินที่ฝาก',
    currencyBalance: 'ยอดตามสกุลเงิน',
    history: 'ประวัติ',
    vaultRules: 'กติกาตู้เซฟ',
    vaultRule1: 'ตู้เซฟเป็นที่เก็บเงินที่ปลอดภัยโดยไม่ต้องกังวลเรื่องค่าธรรมเนียมธุรกรรมหรือความล่าช้าของบล็อกเชน ตู้เซฟทำงานเหมือนกระเป๋าเงินดิจิทัลของคุณเองหรือเหมือนบัญชีออมทรัพย์ธนาคาร ปลอดภัยอย่างยิ่งด้วยระบบ 2FA และคุณสามารถเพิ่มมาตรการความปลอดภัยเพื่อดูแลเงินภายในได้',
    vaultRule2: 'การฝากและถอนเงินในตู้เซฟได้รับการปกป้องด้วย 2FA และผู้ฝากสามารถเข้าถึงได้ตลอดเวลา',
    vaultRule3: 'เงินในตู้เซฟจะไม่มีใครแตะต้องได้นอกจากผู้ฝาก มันเป็นของคุณ และจะปลอดภัยเสมอให้คุณใช้งาน!',
    selectTime: 'เลือกช่วงเวลา',
    colGame: 'เกม',
    colBet: 'เดิมพัน',
    colWin: 'ชนะ',
    colProfit: 'กำไร',
    sports: 'กีฬา',
    allGames: 'เกมทั้งหมด',
    today: 'วันนี้',
    yesterday: 'เมื่อวาน',
    last3Days: '3 วันล่าสุด',
    last7Days: '7 วันล่าสุด',
    last15Days: '15 วันล่าสุด',
    last30Days: '30 วันล่าสุด',
  },
};
